import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  DefaultPaginationValues,
  EventRegistrationAdminTab,
  createSelectionOptionsUtil,
  flattenSponsorRegistrationsWithReps,
  queryString,
} from '../../../Util/commonUtility';
import {
  addNoteByEventRegistrationAPI,
  cancelEventRegistrationsByEventIds,
  deleteToBePaidRegistration as deleteToBePaidRegistrationAction,
  getAllRegistrationByQueryString,
  getRegistrationById,
  getRegistrationByIdForCSV,
  resetEventRegisterCsvDownloadState,
  updateFoodAndRegistrationOptions,
} from '../../../Store/Actions/eventRegister';
import EventRegistrationsComponent from '../../../Components/AdminComponents/EventRegistration';
import {useParams} from 'react-router-dom';
import {setPageNumber, setPageSize} from '../../../Store/Actions/pageSize';
import {getEventOptionsByEventId} from '../../../Store/Actions/eventOptions';
const EventRegistrationContainer = () => {
  const dispatch = useDispatch();
  const {getEventOptionByEventId} = useSelector(
    ({eventOptions}) => eventOptions,
  );
  const {allRegistrationDetailsByEvent} = useSelector(
    ({eventRegister}) => eventRegister,
  );
  const {allRegistrationDetailsByEventForCSV} = useSelector(
    ({eventRegister}) => eventRegister,
  );

  const [allEventRegistrationDataByEvent, setAllEventRegistrationDataByEvent] =
    useState();
  const [
    allEventRegistrationDataByEventForCSV,
    setAllEventRegistrationDataByEventForCSV,
  ] = useState();
  const [eventRegistrationData, setEventRegistrationData] = useState();
  const [eventOptionsFoodData, setEventOptionsFoodData] = useState([]);
  const [allEventOptionsRegistrationData, setAllEventOptionsRegistrationData] =
    useState([]);
  const [eventLocalChapterId, setEventLocalChapterId] = useState();

  const [querySearchValues, setQuerySearchValues] = useState();
  // Admin tabs: normal registrations vs sponsors (with their vendor reps grouped under them).
  const [registrationTab, setRegistrationTab] = useState(
    EventRegistrationAdminTab.registrations,
  );
  const memorizedPageNumber = useSelector(
    ({pageSizes}) => pageSizes.pageNumbers.eventRegistrations,
  );
  const memorizedPageSize = useSelector(
    ({pageSizes}) => pageSizes.pageSizes.eventRegistrations,
  );
  const [pagination, setPagination] = useState({
    page: memorizedPageNumber || DefaultPaginationValues.PAGE,
    pageCount: memorizedPageSize || DefaultPaginationValues.PAGE_SIZE,
    totalPages: DefaultPaginationValues.TOTAL_PAGES,
  });
  const [sortParams, setSortParams] = useState({
    field: 'updated_at',
    order: 'descend',
  });
  const [paginationAndSortChanged, setPaginationAndSortChanged] =
    useState(false);

  const {id} = useParams();
  const reduxSearchValues = useSelector(
    ({dynamicSearch}) => dynamicSearch.searchValues.event_registrations,
  );
  const reduxSearchValueID = useSelector(
    ({dynamicSearch}) => dynamicSearch.searchValueID,
  );
  const searchValues =
    parseInt(id) === reduxSearchValueID ? reduxSearchValues : null;

  const [csvDataLoading, setCSVDataLoading] = useState(false);
  const [totalEventRegistrationCount, setTotalEventRegistrationCount] =
    useState(10);

  const [totalPaidAmount, setTotalPaidAmount] = useState(0);
  const [totalDiscountedAmount, setTotalDiscountedAmount] = useState(0);
  const [totalCreditAmount, setTotalCreditAmount] = useState(0);
  const [totalRefundAmount, setTotalRefundAmount] = useState(0);

  useEffect(() => {
    if (id) {
      fetchEventRegistrations();
      dispatch(getEventOptionsByEventId(id));
    }
  }, [id]);

  useEffect(() => {
    if (allRegistrationDetailsByEvent) {
      setAllEventRegistrationDataByEvent(
        allRegistrationDetailsByEvent?.data?.eventRegistrations,
      );
      setEventLocalChapterId(
        allRegistrationDetailsByEvent?.data?.local_chapter_id,
      );
      if (!searchValues) {
        setTotalPaidAmount(
          allRegistrationDetailsByEvent?.data?.total_paid_amount,
        );

        setTotalCreditAmount(
          allRegistrationDetailsByEvent?.data?.total_credit_amount,
        );

        setTotalDiscountedAmount(
          allRegistrationDetailsByEvent?.data?.total_discount_amount,
        );
        setTotalRefundAmount(
          allRegistrationDetailsByEvent?.data?.total_refund_amount,
        );
      }

      setPagination({
        ...pagination,
        page: allRegistrationDetailsByEvent?.data?.currentPage,
        totalPages: allRegistrationDetailsByEvent?.data?.totalPage,
        totalCount: allRegistrationDetailsByEvent?.data?.totalCount,
      });
      setTotalEventRegistrationCount(
        allRegistrationDetailsByEvent?.data?.totalCount,
      );
    } else {
      fetchEventRegistrations();
    }
  }, [allRegistrationDetailsByEvent]);

  useEffect(() => {
    if (allRegistrationDetailsByEventForCSV) {
      setAllEventRegistrationDataByEventForCSV(
        flattenSponsorRegistrationsWithReps(
          allRegistrationDetailsByEventForCSV?.data?.eventRegistrations,
        ),
      );
    }
  }, [
    allRegistrationDetailsByEventForCSV?.data?.eventRegistrations,
    totalEventRegistrationCount,
  ]);

  useEffect(() => {
    if (getEventOptionByEventId) {
      const filteredRegData =
        getEventOptionByEventId?.data?.registration?.filter(
          (reg) => reg?.is_vendor === false,
        );
      const foodOptions = getEventOptionByEventId?.data?.food;
      const createUtilData = foodOptions
        ? createSelectionOptionsUtil(
            foodOptions,
            'id',
            'name',
            'price',
            undefined,
          )
        : [];
      const foodOptionsWithNoFood = [
        ...createUtilData,
        {value: 'no-food', label: 'No Food'},
      ];
      setEventOptionsFoodData(foodOptionsWithNoFood);
      setAllEventOptionsRegistrationData(
        createSelectionOptionsUtil(
          filteredRegData,
          'id',
          'name',
          'price',
          undefined,
        ),
      );
    } else {
      dispatch(getEventOptionsByEventId(id));
    }
  }, [getEventOptionByEventId]);

  useEffect(() => {
    if (eventRegistrationData) {
      setPagination({
        ...pagination,
        page: eventRegistrationData?.data?.currentPage,
        totalPages: eventRegistrationData?.data?.totalPage,
        totalCount: eventRegistrationData?.data?.totalCount,
      });
    }
  }, [eventRegistrationData]);

  useEffect(() => {
    if (paginationAndSortChanged) {
      fetchEventRegistrations(searchValues);
      setPaginationAndSortChanged(false);
    }
  }, [paginationAndSortChanged]);

  useEffect(() => {
    if (searchValues) {
      dispatch(setPageNumber('eventRegistrations', 1));
      setPagination({
        ...pagination,
        page: 1,
      });
      setPaginationAndSortChanged(true);
    }
    dispatch(resetEventRegisterCsvDownloadState());
    setCSVDataLoading(false);
  }, [searchValues]);

  const handlePaginationChange = (current, pageSize) => {
    dispatch(setPageSize('eventRegistrations', pageSize));
    dispatch(setPageNumber('eventRegistrations', current));
    setPagination({
      ...pagination,
      page: current,
      pageCount: pageSize,
    });
    setPaginationAndSortChanged(true);
  };

  const handleTableChange = (pagination, filter, sorter) => {
    if (sorter?.field && sorter?.order) {
      setSortParams({
        field: sorter.field,
        order: sorter.order,
      });
    }
    setPaginationAndSortChanged(true);
    dispatch(resetEventRegisterCsvDownloadState());
    setCSVDataLoading(false);
  };

  const withRegistrationTab = (searchQueryData, tab = registrationTab) =>
    `${searchQueryData ? `${searchQueryData}&` : ''}tab=${tab}`;

  const fetchEventRegistrations = (
    searchValues,
    tab = registrationTab,
    paginationValues = pagination,
  ) => {
    setQuerySearchValues(searchValues);
    const sortField = sortParams.field || '';
    const sortOrder = sortParams.order || '';
    const searchQueryData = withRegistrationTab(queryString(searchValues), tab);
    dispatch(
      getRegistrationById(
        paginationValues,
        sortField,
        sortOrder,
        searchQueryData,
        id,
      ),
    );
  };
  const fetchEventRegistrationsForCSV = (searchValues) => {
    setQuerySearchValues(searchValues);
    const sortField = sortParams.field || '';
    const sortOrder = sortParams.order || '';
    const searchQueryData = withRegistrationTab(queryString(searchValues));
    dispatch(
      getRegistrationByIdForCSV(
        sortField,
        sortOrder,
        searchQueryData,
        totalEventRegistrationCount,
        id,
        setCSVDataLoading,
      ),
    );
  };

  const handleRegistrationTabChange = (tab) => {
    setRegistrationTab(tab);
    dispatch(setPageNumber('eventRegistrations', 1));
    dispatch(resetEventRegisterCsvDownloadState());
    setCSVDataLoading(false);
    const firstPage = {...pagination, page: 1};
    setPagination(firstPage);
    fetchEventRegistrations(searchValues, tab, firstPage);
  };

  const cancelEventRegistrations = (eventIds, setSelectedRowKeys) => {
    return dispatch(
      cancelEventRegistrationsByEventIds(eventIds, setSelectedRowKeys),
    );
  };

  const UpdateRegistrationOptions = async (
    data,
    registrationId,
    setEditingKey,
  ) => {
    const result = await dispatch(
      updateFoodAndRegistrationOptions(data, registrationId, setEditingKey),
    );
    // Status changes (for example To Be Paid → Paid) change in-person usage
    // and may raise capacity. The warning on the next edit reads this snapshot,
    // so refresh it before the admin edits another registration.
    if (result?.success && id) {
      await dispatch(getEventOptionsByEventId(id));
    }
    return result;
  };

  const addNoteByEventRegistration = (eventRegistrationId, note) => {
    const payload = {
      eventRegistrationId: eventRegistrationId,
      note: note,
    };
    dispatch(addNoteByEventRegistrationAPI(payload));
  };

  return (
    <div>
      <EventRegistrationsComponent
        foodOptions={eventOptionsFoodData}
        registrationOptions={allEventOptionsRegistrationData}
        eventOptionsByType={getEventOptionByEventId?.data}
        allEventRegistrationData={allEventRegistrationDataByEvent}
        allEventRegistrationDataForCSV={allEventRegistrationDataByEventForCSV}
        totalPaidAmount={totalPaidAmount}
        totalDiscountedAmount={totalDiscountedAmount}
        totalCreditAmount={totalCreditAmount}
        totalRefundAmount={totalRefundAmount}
        paging={pagination}
        handlePaginationChange={(page, pageSize) => {
          handlePaginationChange(page, pageSize);
        }}
        handleTableChange={handleTableChange}
        sortParams={sortParams}
        fetchEventRegistrations={(searchValues) => {
          fetchEventRegistrations(searchValues);
        }}
        fetchEventRegistrationsForCSV={(searchValues) => {
          fetchEventRegistrationsForCSV(searchValues);
        }}
        cancelEventRegistrations={cancelEventRegistrations}
        UpdateRegistrationOptions={(data, id, clearEdit) =>
          UpdateRegistrationOptions(data, id, clearEdit)
        }
        searchValues={searchValues}
        registrationTab={registrationTab}
        onRegistrationTabChange={handleRegistrationTabChange}
        csvDataLoading={csvDataLoading}
        eventLocalChapterId={eventLocalChapterId}
        addNoteByEventRegistration={(eventRegistrationId, note) => {
          addNoteByEventRegistration(eventRegistrationId, note);
        }}
        deleteToBePaidRegistration={(registrationId, onSuccess) => {
          dispatch(deleteToBePaidRegistrationAction(registrationId, onSuccess));
        }}
      />
    </div>
  );
};

export default EventRegistrationContainer;
